import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Scoped to /admin/ only - this service worker exists purely for installability
// and push notifications, not offline caching (see public/service-worker.js).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/admin/' }).catch((err) => {
      console.error('Service worker registration failed:', err);
    });
  });
}